export type ValueOf<T> = T[keyof T];

export function getPropertyObject(object: any): any {
  const newObject: any = {};
  Object.getOwnPropertyNames(object).map((key: string) => {
    newObject[key] = object[key];
  });
  return newObject;
}

export const hasProperty = (obj, key) => {
  return !!obj && Object.prototype.hasOwnProperty.call(obj, key);
};

export function isObjectEmpty(object: any): boolean {
  return Object.keys(object).length === 0;
}

export function objectToFormData(obj: any, form: any, namespace: string): any {
  const fd: any = form || new FormData();
  let formKey: string;

  Object.keys(obj).forEach((property: string) => {
    if (Object.prototype.hasOwnProperty.call(obj, property)) {
      if (namespace) {
        formKey = `${namespace}[${property}]`;
      } else {
        formKey = property;
      }

      if (
        typeof obj[property] === "object" &&
        !(obj[property] instanceof File)
      ) {
        objectToFormData(obj[property], fd, property);
      } else {
        // if it's a string or a File object
        fd.append(formKey, obj[property]);
      }
    }
  });

  return fd;
}

export function dotize(obj: any, prefix = "") {
  let newObj = {};

  const recurse = (o, p, isArrayItem = false) => {
    for (const f in o) {
      // eslint-disable-next-line no-prototype-builtins
      if (o.hasOwnProperty(f) && o[f] && typeof o[f] === "object") {
        if (Array.isArray(o[f]))
          newObj = recurse(o[f], (p ? p + "." : "") + f, true);
        // array
        else {
          if (isArrayItem) newObj = recurse(o[f], (p ? p : "") + "[" + f + "]");
          // array item object
          else newObj = recurse(o[f], (p ? p + "." : "") + f); // object
        }
      } else {
        if (isArrayItem) newObj[p + "[" + f + "]"] = o[f];
        // array item primitive
        else newObj[p + "." + f] = o[f]; // primitive
      }
    }
    return newObj;
  };

  return recurse(obj, prefix);
}

export function removeEmpty(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => v != null && v != ""),
  );
}

export function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}
